module.exports = __webpack_public_path__ + "media/images/icons/outlined/arrow-up-74088644825662afab3b65b474085fd2.svg";